import Screen from '@screen';
import styled from 'styled-components';

const TopBarUser = styled.span<React.CSSProperties>`
  align-self: center;
  margin-right: ${12 * Screen.widthRatio}px;
`;

export default TopBarUser;
